import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import _ from 'underscore';
import ModalActionCreator from 'action_creators/modal';
import MessageGuide from 'views/plugins/confirmation/message_guide';
import Body from 'views/plugins/confirmation/body';
import Cover from 'views/plugins/checkout/mobile/screens/cover';
import { t } from 'services/translation';

import styled from '@emotion/styled';
import { Theme } from 'ui_system/theme';

const ThankYou = styled.h2`
  padding-top: 32px;
  margin-top: 0;
  font-size: 26px;
  margin-bottom: 16px;
  font-weight: 500;
`;

const SendMessage = styled.a`
  color: ${Theme.colors.linksDesignElementsBaseColor};
`;

const TourName = styled.h3`
  color: ${Theme.colors.previewSecondaryTextColor};
  margin-top: 8px;
`;

const AllSetText = styled.p``;

class ConfirmationMobileMessage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: this.props.tourist_email,
      displayError: false,
    };
  }

  static displayName = 'ConfirmationMobile-MessageScreen-Plugins';

  static propTypes = {
    tour_picture: PropTypes.string.isRequired,
  };

  setEmail = (value) => {
    let displayError;
    //check if email is valid
    if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      displayError = false;
    } else {
      displayError = true;
    }
    //Update the value in the input box regardless of validity
    this.setState({
      displayError,
      email: value,
    });
  };

  _showMessageGuideModal = (e) => {
    e.preventDefault();
    ModalActionCreator.show({
      content: (
        <MessageGuide {...this._messageGuideProps()} email={this.state.email} />
      ),
      triggeringElement: e.currentTarget,
      className: 'Confirmation-Message-Guide-Modal small',
    });
  };

  _messageGuideProps = () => {
    return {
      guide_full_name: this.props.guide_full_name,
      recipient_id: this.props.recipient_id,
      sender_id: this.props.sender_id,
      booking_id: this.props.booking_id,
    };
  };

  _messageGuideFooterContent = () => {
    const { affiliate_portal_link } = this.props;
    if (affiliate_portal_link) return null;

    const style = { color: this.props.link_color };

    return (
      <p>
        {t('HAVE_QUESTIONS_FOR_US')}?<br />
        <SendMessage
          href=""
          onClick={this._showMessageGuideModal}
          style={style}
        >
          {t('SEND_A_MESSAGE')}
        </SendMessage>
      </p>
    );
  };

  _viewProps = () => {
    const {
      show_details,
      paid_in_cash,
      custom_title,
      custom_body,
      link_color,
      ticketed_event,
    } = this.props;

    return {
      ...this.props,
      footer_content: this._messageGuideFooterContent(),
      show_details,
      paid_in_cash,
      custom_title,
      custom_body,
      link_color,
      ticketed_event,
    };
  };

  _coverProps = () => {
    return {
      forInvoice: this.props.for_invoice,
      guestPaidInvoice: this.props.guest_paid_invoice,
      tourPicture: this.props.tour_picture,
      guideAvatar: this.props.guide_avatar,
      tourName: this.props.tour_name,
      guideName: this.props.guide_full_name,
      hasResource: this.props.has_resource,
      resourceName: this.props.resource_name,
      isLiveBooking: this.props.is_live_booking,
      linkColor: this.props.link_color,
      brandColor: this.props.brand_color,
      businessName: this.props.business_name,
      liveBrandingColor: this.props.live_branding_color,
    };
  };

  _renderLiveBody = () => {
    const { is_live_booking, tour_name, guide_full_name, first_name } =
      this.props;
    return (
      <div>
        <TourName>{tour_name}</TourName>
        <ThankYou>
          {this.props.headline ||
            t('THANK_YOU_WITH_NAME', '', { name: first_name })}
        </ThankYou>
        <AllSetText>
          <div
            dangerouslySetInnerHTML={{
              __html: this.props.sub_headline || `${t('YOU_ARE_ALL_SET')}`,
            }}
          />
        </AllSetText>
      </div>
    );
  };

  render() {
    const { is_live_booking } = this.props;
    const confirmationCssClasses = classnames(
      'ConfirmationMobile-PageContent',
      {
        'is-live': is_live_booking,
      }
    );

    return (
      <div
        className={`ConfirmationMobile-Screen ConfirmationMobile-Message ${
          is_live_booking && 'liveBooking-Container'
        }`}
      >
        {!is_live_booking && (
          <div className="ConfirmationMobile-ScreenHeader transition-ctx">
            {t('THANK_YOU')}!
          </div>
        )}
        <div className="ConfirmationMobile-ScreenContent transition-ctx">
          <Cover {...this._coverProps()} />
          <div className={confirmationCssClasses}>
            {is_live_booking ? (
              this._renderLiveBody()
            ) : (
              <Body
                {...this._viewProps()}
                displayError={this.state.displayError}
                email={this.state.email}
                setEmail={this.setEmail}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default ConfirmationMobileMessage;
